import { useEffect } from 'react'

import { Actions, Entities } from '@space-core/datahub'
import DataHubService from '@space-core/datahub/hotmartClub/dataHubService'

import type { ShowcaseOrientation } from '@space-core/enum/showcase'
import { toastEventDispatch } from '@space-events/toast'
import { useDataHubEvents } from '@space-shell/common/hooks/useDataHubEvents'
import { useMembershipStore, useUserInfoStore, TOAST_EVENT_KEY } from '@space-shell/core/store'
import { ViewHomePageSchema } from '@space-shell/modules/home/datahub/schemas/view/viewHomePageSchema'

const useHome = () => {
  const user = useUserInfoStore()
  const { sendDataHubEvent } = useDataHubEvents()
  const { membershipData } = useMembershipStore()

  useEffect(() => {
    const isValidUser = user?.name && user?.role

    if (isValidUser) {
      const viewSchema = new ViewHomePageSchema({
        userRole: user.role
      })

      DataHubService.sendEvent({ schema: viewSchema })
    }
  }, [user])

  useEffect(() => {
    const toastDetail = window.localStorage.getItem(TOAST_EVENT_KEY)
    if (toastDetail) {
      toastEventDispatch(JSON.parse(toastDetail))
      localStorage.removeItem(TOAST_EVENT_KEY)
    }
  }, [])

  useEffect(() => {
    sendDataHubEvent({
      group: Entities.HOME,
      name: Actions.VIEW_HOME,
      params: {
        home: {
          orientation: membershipData?.settings?.orientation as unknown as ShowcaseOrientation
        }
      }
    })
  }, [sendDataHubEvent, membershipData?.settings?.orientation])
}

export default useHome
